import { Discount } from '../../../types/discounts';


export const getNextPageArgs = (discounts: Discount[]): { [key: string]: string } => {
    if (discounts.length === 0) {
        return {};
    }
    const last = discounts[discounts.length - 1];
    // @ts-ignore
    return { starting_after: last.ref_id || '' };
};

export const getDiscountImage = (discount: Discount): string | null => {
    const links = discount.links || [];
    const variants = ['large_discount_image', 'medium_discount_image', 'thumbnail_discount_image'];
    const image = variants.map(variant => links.find(l => l.rel === variant)).find(x => x);
    return (image && image.href) || null;
};
